import { redirect } from 'next/navigation';

interface RedirectDetailPageProps {
  return_code?: number;
  pathname: string;
}

const getRedirectMessage = (returnCode?: number) => {
  switch (returnCode) {
    case 24040:
      return '존재하지 않는 페이지입니다.';
    case 20019:
    case 24041:
      return '숨김 처리된 페이지입니다.';
    default:
      return null;
  }
};

const withToast = (pathname: string, message: string) => {
  const separator = pathname.includes('?') ? '&' : '?';

  return `${pathname}${separator}toast=${encodeURIComponent(message)}`;
};

/** 서버 컴포넌트용 */
export const redirectDetailPage = ({
  return_code,
  pathname,
}: RedirectDetailPageProps) => {
  const message = getRedirectMessage(return_code);
  if (message) {
    redirect(withToast(pathname, message));
  }
};

/** 클라이언트 컴포넌트용 - 리다이렉트 필요 여부와 URL 반환 */
export const getRedirectDetailPage = ({
  return_code,
  pathname,
}: RedirectDetailPageProps) => {
  const message = getRedirectMessage(return_code);

  return {
    shouldRedirect: !!message,
    redirectUrl: message ? withToast(pathname, message) : null,
  };
};
